<template>
    <div class="navbar-wrap">
        <van-nav-bar
            class="navbar"
            :title="headerTitle"
            :placeholder="false"
            :safe-area-inset-top="true"
            fixed
            :border="false"
            :left-arrow="true"
            @click-left="goBack"
        ></van-nav-bar>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
// import { getLogout } from '@api/user';
// import toLogin from '@libs/login';
export default {
    name: 'Header',
    data() {
        return {};
    },
    inject: ['app'],
    computed: mapGetters(['headerTitle', 'userInfo', 'isLogin', 'web3']),
    components: {},
    mounted() {
        this.init(this.$route);
    },
    watch: {
        $route(to) {
            this.init(to);
        },
        userInfo: {
            handler(newInfo, oldInfo) {
                if (newInfo && oldInfo) {
                    this.oauth();
                }
            },
            immediate: true
        }
    },
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.isBack = true;
                this.$router.back();
            } else {
                this.$router.replace('/');
            }
        },
        init(to) {
            console.log(to.name);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@assets/css/config.scss';
.navbar-wrap {
    height: 92px;
    .navbar.van-nav-bar {
        background: $base-navbar-bgcolor;
        ::v-deep .van-nav-bar__content {
            background: $base-navbar-bgcolor;
            .van-nav-bar__left {
                .van-icon {
                    color: $base-font-color;
                }
            }
            .van-nav-bar__title {
                color: $base-font-color;
            }
        }
    }
}
</style>
